var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.482 1.207A8.804 8.804 0 0 1 9 0c1.633 0 3.139.402 4.518 1.207a8.96 8.96 0 0 1 3.275 3.275A8.804 8.804 0 0 1 18 9a8.804 8.804 0 0 1-1.207 4.518 8.96 8.96 0 0 1-3.275 3.275A8.804 8.804 0 0 1 9 18a8.804 8.804 0 0 1-4.518-1.207 8.96 8.96 0 0 1-3.275-3.275A8.804 8.804 0 0 1 0 9c0-1.633.402-3.139 1.207-4.518a8.96 8.96 0 0 1 3.275-3.275Zm5.913 13.682a.385.385 0 0 0 .105-.276v-2.226a.385.385 0 0 0-.105-.276.342.342 0 0 0-.258-.111h-2.25a.37.37 0 0 0-.27.117.37.37 0 0 0-.117.27v2.226c0 .102.04.192.117.27a.37.37 0 0 0 .27.117h2.25a.342.342 0 0 0 .258-.111Zm-.041-4.102a.296.296 0 0 0 .123-.205l.21-7.277a.23.23 0 0 0-.117-.211.436.436 0 0 0-.28-.094H7.71a.436.436 0 0 0-.28.094.23.23 0 0 0-.117.21l.199 7.278c0 .078.039.147.117.205a.455.455 0 0 0 .281.088h2.168a.43.43 0 0 0 .276-.088Z",
    fill: "#f59a23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAlert);
export default __webpack_public_path__ + "static/media/task-alert.8a806229.svg";
export { ForwardRef as ReactComponent };